import { pageTitleHeight } from '@/constants'
import PageTitle from '@components/PageTitle/PageTitle'
import { useBoolVariation } from '@launchdarkly/react-sdk'
import { Box, List, ListItemButton, ListItemText, Paper, Stack, useTheme } from '@mui/material'
import { Outlet, Link as RouterLink, useMatch } from 'react-router-dom'

import AnalyticsOld from './AnalyticsOld/AnalyticsOld'

/**
 * Display the analytics landing page. The redesigned view is gated behind the
 * pal-score-migration feature flag; the legacy page renders while it is off.
 */
export default function Analytics() {
	const palScoreMigrationEnabled = useBoolVariation('feature-art-1621-pal-score-migration', false)

	if (!palScoreMigrationEnabled) return <AnalyticsOld />

	return <AnalyticsUI />
}

export function AnalyticsUI() {
	return (
		<Box width="100%" data-testid="analytics">
			<PageTitle title="Analytics" />
			<Box px="2rem" pb="2rem">
				<Stack direction="row" gap={2} justifyContent="center">
					<Box
						sx={{
							width: '100%',
							maxWidth: '15rem',
						}}
					>
						<Menu />
					</Box>
					<Box sx={{ width: '100%' }}>
						<Outlet />
					</Box>
				</Stack>
			</Box>
		</Box>
	)
}

function Menu() {
	const theme = useTheme()

	return (
		<Paper
			elevation={0}
			sx={{
				position: 'sticky',
				top: pageTitleHeight,
				border: `1px solid ${theme.palette.divider}`,
				borderRadius: '0.5rem',
				overflow: 'hidden',
			}}
			data-testid="menu"
		>
			<List>
				<MenuItem view="market-baskets" label="Market Baskets" />
				<MenuItem view="action-center" label="Action Center" />
				<MenuItem view="matching" label="Matching" />
				<MenuItem view="segments" label="Segments" />
			</List>
		</Paper>
	)
}

type MenuItemProps = {
	view: string
	label: string
}

function MenuItem({ view, label }: MenuItemProps) {
	const to = `/app/market-baskets/analytics/${view}`
	const selected = Boolean(useMatch(to))

	return (
		<ListItemButton component={RouterLink} to={to} selected={selected} data-testid={`menu-${view}`}>
			<ListItemText primary={label} />
		</ListItemButton>
	)
}
